import React from 'react';
import { theme, Card, Heading4, Row, Col } from '@ovotech/element-v5';
import {
  TabButton,
  TabButtonGroup,
} from '../pages/ProductSelection/ProductSelection.styled';
import styled from 'styled-components';

export const ProductType = {
  MONTHLY: 'monthly',
  PAYG: 'payg',
} as const;

export type ProductType = (typeof ProductType)[keyof typeof ProductType];

interface PlanSelectorProps {
  activeTab: ProductType;
  onTabChange: (tab: ProductType) => void;
  heading: string;
  showMonthlyPlans: boolean;
}

const StyledHeading4 = styled(Heading4)`
  color: ${theme.color.brand.dim};
  font-size: ${theme.unit['500']} !important;
  padding-top: ${theme.space['400']};
  padding-bottom: ${theme.space['400']};
  ${({ theme }) => theme.mediaQueries.mediumAndUp} {
    margin-bottom: ${theme.space['0']};
    font-size: ${theme.unit['600']} !important;
  }
`;

const StyledCard = styled(Card)`
  background-color: ${theme.color.surface.surface};
  border-radius: ${theme.space['0']};
  outline: none;
  padding: 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${theme.space['600']} ${theme.space['400']};
`;

export const PlanSelector: React.FC<PlanSelectorProps> = ({
  activeTab,
  onTabChange,
  heading,
  showMonthlyPlans,
}) => (
  <StyledCard>
    <Row
      isNested
      style={{
        padding: `${theme.space['600']} ${theme.space['400']}`,
        alignItems: 'center',
      }}
    >
      <Col small={12} medium={7}>
        <StyledHeading4>{heading}</StyledHeading4>
      </Col>
      <Col small={12} medium={5}>
        {showMonthlyPlans && (
          <TabButtonGroup>
            <TabButton
              isActive={activeTab === 'monthly'}
              onClick={() => onTabChange(ProductType.MONTHLY)}
            >
              Pay monthly
            </TabButton>
            <TabButton
              isActive={activeTab === 'payg'}
              onClick={() => onTabChange(ProductType.PAYG)}
            >
              Pay as you go
            </TabButton>
          </TabButtonGroup>
        )}
      </Col>
    </Row>
  </StyledCard>
);
